module.exports = __webpack_public_path__ + "img/7.27154a48.png";